let CollectionSelector = function () {
    const CHECKBOX    = 'use_for_collection';
    const COLLECTIONS = 'collection_container';

    let init = () => {
        let checkbox = document.getElementById(CHECKBOX);
        check(checkbox);
        checkbox.addEventListener('change', function(e) {
            check(this);
        });
    };

    let check = (checkbox) => {
        if (checkbox.checked) {
            showCollections();
        } else {
            hideCollections();
        }
    };

    let hideCollections = () => {
        let collections = document.getElementById(COLLECTIONS);
        collections.hidden = true;
    };

    let showCollections = () => {
        let collections = document.getElementById(COLLECTIONS);
        collections.hidden = false;
    };

    return {
        init: init
    }
}();

export default CollectionSelector;
